import { webApi } from '@mi-front/api-clients';
import { useMemo } from 'react';
import { getStablePosterUri } from '../utils/poster-cache';

type PosterSize = 'h180' | 'h360' | 'h720';

/** Stable URIs per size (first-seen URI for each variant, cached by fragment id + size). */
export type StablePosterUris = Record<PosterSize, string>;

/**
 * Returns stable poster URIs for the fragment so the same URL is used for the session.
 * Prevents flicker when the API returns a newer signed URI after filtering/remount.
 */
export function useStablePoster(
  fragment: webApi.FragmentListItemDto | null | undefined,
): StablePosterUris | null {
  return useMemo(() => {
    if (!fragment?.poster) return null;
    const { id, poster } = fragment;
    return {
      h180: getStablePosterUri(id, 'h180', poster.h180.uri),
      h360: getStablePosterUri(id, 'h360', poster.h360.uri),
      h720: getStablePosterUri(id, 'h720', poster.h720.uri),
    };
  }, [
    fragment?.id,
    fragment?.poster?.h180?.uri,
    fragment?.poster?.h360?.uri,
    fragment?.poster?.h720?.uri,
  ]);
}
